import { addClass } from "./functions";


class lazyLoad {
    _el             : NodeListOf<Element>;
    _elArray        : Array<object>;
    _lazyLoadInit   : boolean;
    _loadedClassName: string;
    _inAdvance      : number;

    constructor(el: NodeListOf<Element>, inAdvance){
        this._el              = el;
        this._lazyLoadInit    = false;
        this._loadedClassName = 'loaded';
        this._inAdvance       = inAdvance;
        this._elArray         = [];
    }

    init = () => {
        if( !this._lazyLoadInit ){
            this.elArray();
            this.load();
            this.addEvent();
            this._lazyLoadInit = true;
        }
    }

    elArray = () => {
        this._el.forEach(el => {
            this._elArray.push({ domEl: el, imgLoaded: false });
        })
    }

    load = () => {

        this._elArray.forEach(el => {
            
            let imgEl = el['domEl'];
            
            let imgLoaded = el['imgLoaded'];
            let dataBg = imgEl.dataset.src;
            
            
            if (imgEl.offsetTop < window.innerHeight + window.pageYOffset + this._inAdvance) { 
                // If image not already loaded 
                if(!imgLoaded){                    
                    // Create a temporary img, to load
                    let preloaderImg = document.createElement("img");
                    preloaderImg.src = dataBg;
                    // Set background on dom element when loaded
                    preloaderImg.addEventListener('load', (event) => {
                        imgEl.style.backgroundImage = `url(${dataBg})`;
                        imgEl.style.opacity = "1";
                        addClass( {domElement: imgEl, classList: 'loaded'} )
                    });
                    el['imgLoaded'] = true;
                }
            }
        });
    };

    resize = () => {
        this._elArray.forEach(el => {
            el['imgLoaded'] = el['imgLoaded'] ? false : el['imgLoaded'];
        })
        this.load;
    }

    // Add event listener
    addEvent = () => {
        //lazy load the function when window is scrolled
        window.addEventListener('scroll', this.load);
        //lazy load the function when window is resized
        window.addEventListener('resize', this.resize);
    } 
}

export default lazyLoad;